/*
 * @Author: liuxuanxuan
 * @Date: 2021-07-22 17:26:53
 * @Last Modified by: liuxuanxuan
 * @Last Modified time: 2021-12-13 16:39:03
 */
import axios from 'axios';
import qs from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import router from '@/router';
import store from '@/store';
import { Message ,MessageBox } from 'element-ui';
// export let baseURL = process.env.NODE_ENV == 'development' ? 'https://bbs-api.dahe.cn/' : 'https://bbs-api.dahe.cn/';
// console.log(process.env);
export let baseURL = process.env.API_ROOT;

let instance = axios.create({
    baseURL,
    timeout: 1000 * 30,//超过30s
    transformRequest: [
        data => {
            if (data && (typeof data.get !== 'function') && typeof data !== 'string') {
                for (let i in data) {
                    if (data[i] === '' || data[i] === null || data[i] === undefined) {
                        delete data[i];
                    }
                }
                
                //把data转换成formdata
                return qs.stringify(data);
            }else {
                return data
            }
        }
    ],

});

//在urls里的接口不传token
let urls = [
    // '/pc/index/article/list',
    '/pc/index/channel/detail',
    '/pc/index/sign-hot',
    '/pc/discuss/list',
    '/app/discuss/list',
]
// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。

        if(!urls.includes(config.url)){
            const token = store.state.UserToken;
            token && (config.headers.Token = token);
            if(config.url=='/app/index/article/detail'||config.url=='/app/index/activity/detail'||config.url=='/app/index/sign-hot'||config.url=='/app/c3/news/detail'||config.url=='/app/vote/handle'){
                const ua = getEnv();
                ua && (config.headers.Ua = ua);
            }
        }

        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        if (response.status == 200) {
            if (response.data.code !== 200) {
                // messageTip(response.data.msg);
                errorHandle(response.data.code,response.data.msg);
                return Promise.reject(response);
            } else {
                return response;
            }
        } else {
            errorHandle(response.data.code,response.data.msg);
            return Promise.reject(response);
        }
    },
    error => {
        // 对响应错误做点什么
        // 网络超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !error.config._retry) {
            messageTip('网络超时，请稍后重试')
          }
        error.data && errorHandle(error.data.code,error.data.msg);
        return Promise.reject(error);
    }
);

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 1001: 未登录状态，跳转登录页
        case 1001:
            toLogin();
            break;
        // 1002 token过期
        // 清除token并跳转登录页
        case 1002:
            localStorage.removeItem('UserToken');
            localStorage.removeItem('UserInfo');
            messageTip(other);
            store.commit('SET_USERTOKEN', '');
            store.commit('SET_USERINFO', {});
            setTimeout(() => {
                toLogin();
            }, 1000);
            break;
        // 2002 token校验失败
        case 2002:
            toLogin();
            break;
        // 404请求不存在
        case 404:
            router.replace({
                path: '/404'
            });
            break;
        default:
            messageTip(other);
    }
}

/**
 * 跳转登录页
 * 携带当前页面路由，以便在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    Message({
        message: "请登录后查看",
        type: 'warning',
        duration: 2000,
        // onClose: function(){

        // }
    });
    // router.replace({
    //     path: '/login',
    //     query: {
    //         redirect: router.currentRoute.fullPath
    //     }
    // });
}
const messageTip = msg => {
    Message({
        message: msg,
        type: 'error'
    });
};

const getEnv = () => {
    let ua = window.navigator.userAgent.toLowerCase(),
        app = '';
        console.log(ua);
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      app = 'weixin';
    }else if (ua.indexOf('yydh_android') !== -1) {
      app = 'forum_android'
    }else if (ua.indexOf('yydh_ios') !== -1) {
      app = 'forum_ios'
    }else{
      app = "other"
    }
    return app;
};
export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js